import React from 'react';
import type { Step } from 'react-joyride';
import { APP_NAME } from '../../config/region';

export const onboardingTourSteps: Step[] = [
  {
    target: 'body',
    content: (
      <div>
        <h3 className="text-lg font-bold text-white mb-2">Welcome to {APP_NAME}! 🎉</h3>
        <p className="text-gray-300">
          Let's take a quick tour to help you get started. We'll show you all the key features and pages.
        </p>
      </div>
    ),
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="sidebar"]',
    content: (
      <div>
        <h3 className="text-lg font-bold text-white mb-2">Navigation Sidebar</h3>
        <p className="text-gray-300">
          Use this sidebar to navigate between different sections. You'll find all main features organized here.
        </p>
      </div>
    ),
    placement: 'right',
  },
  {
    target: '[data-tour="dashboard"]',
    content: (
      <div>
        <h3 className="text-lg font-bold text-white mb-2">Dashboard</h3>
        <p className="text-gray-300">
          Your command center! View campaign statistics, recent runs, credit balance, and quick actions all in one place.
        </p>
      </div>
    ),
    placement: 'right',
    spotlightPadding: 0,
  },
  {
    target: '[data-tour="campaigns"]',
    content: (
      <div>
        <h3 className="text-lg font-bold text-white mb-2">Campaigns</h3>
        <p className="text-gray-300">
          Your outbound initiatives. A Campaign carries the audience, owner,
          status lifecycle, goals + KPIs, and a retry strategy — it places the
          calls and dispatches follow-ups automatically.
        </p>
      </div>
    ),
    placement: 'right',
    spotlightPadding: 0,
  },
  {
    target: '[data-tour="leads"]',
    content: (
      <div>
        <h3 className="text-lg font-bold text-white mb-2">Leads Management</h3>
        <p className="text-gray-300">
          Manage your contact database. Upload, edit, and organize your leads before creating campaigns.
        </p>
      </div>
    ),
    placement: 'right',
    spotlightPadding: 0,
  },
  {
    target: '[data-tour="inbound-calls"]',
    content: (
      <div>
        <h3 className="text-lg font-bold text-white mb-2">Inbound Calls</h3>
        <p className="text-gray-300">
          Handle incoming calls with your AI assistant. Configure settings and view call history here.
        </p>
      </div>
    ),
    placement: 'right',
    spotlightPadding: 0,
  },
  {
    target: '[data-tour="analytics"]',
    content: (
      <div>
        <h3 className="text-lg font-bold text-white mb-2">Analytics</h3>
        <p className="text-gray-300">
          Track your campaign performance with detailed analytics, charts, and insights to optimize your results.
        </p>
      </div>
    ),
    placement: 'right',
    spotlightPadding: 0,
  },
  {
    target: '[data-tour="credits"]',
    content: (
      <div>
        <h3 className="text-lg font-bold text-white mb-2">Credits</h3>
        <p className="text-gray-300">
          View your credit balance and transaction history. Credits are used for call minutes.
        </p>
      </div>
    ),
    placement: 'right',
    spotlightPadding: 0,
  },
  {
    target: '[data-tour="subscription"]',
    content: (
      <div>
        <h3 className="text-lg font-bold text-white mb-2">Subscription</h3>
        <p className="text-gray-300">
          Manage your subscription plan, view billing information, and upgrade to unlock more features.
        </p>
      </div>
    ),
    placement: 'right',
    spotlightPadding: 0,
  },
  {
    target: '[data-tour="feedback"]',
    content: (
      <div>
        <h3 className="text-lg font-bold text-white mb-2">Feedback</h3>
        <p className="text-gray-300">
          Share your thoughts and suggestions to help us improve {APP_NAME}. We value your feedback!
        </p>
      </div>
    ),
    placement: 'right',
    spotlightPadding: 0,
  },
  {
    target: '[data-tour="support"]',
    content: (
      <div>
        <h3 className="text-lg font-bold text-white mb-2">Support</h3>
        <p className="text-gray-300">
          Get help when you need it. Submit support tickets and access our knowledge base.
        </p>
      </div>
    ),
    placement: 'right',
    spotlightPadding: 0,
  },
  {
    target: '[data-tour="settings"]',
    content: (
      <div>
        <h3 className="text-lg font-bold text-white mb-2">Settings</h3>
        <p className="text-gray-300">
          Customize your account settings, preferences, and manage your profile information.
        </p>
      </div>
    ),
    placement: 'right',
    spotlightPadding: 0,
  },
];
